import { makeStyles } from "@material-ui/core/styles";
import theme from "theme";

const useStyles = makeStyles({
  backpane: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100vh",
  },
  line: {
    borderTop: "3px solid #FFFFFF",
    opacity: 1,
    width: "10%",
    height: "0px",
    marginBottom: theme.spacing(3),
  },

  imgpad: {
    paddingLeft: theme.spacing(2),
  },
  imgpadxs: {
    margin: theme.spacing(2),
  },
  imgmarxs: {
    margin: theme.spacing(1),
  },
  applogo: {
    opacity: 1,
    borderRadius: "112px",
  },
  leftContent: {
    height: "100%",
    padding: theme.spacing(1),
    color: "#FFFFFF",
    background: "#153C65A8 0% 0% no-repeat padding-box",
  },
  rightContent: {
    height: "100%",
    padding: theme.spacing(1),
    color: "#FFFFFF",
  },
  content: {
    height: "100%",
  },
  image: {
    objectFit: "contain",
  },
  explore: {
    marginTop: theme.spacing(4),
  },
  copyright: {
    font: "normal normal normal 15px/17px Arial",
    letterSpacing: "0px",
    color: "#FFFFFF",
    opacity: 1,
  },
});

export default useStyles;
